import {Directive, Input, OnInit, TemplateRef, ViewContainerRef} from '@angular/core';
import {UserRole} from "@shared/enums/user-roles.enum";

type UserRoleType = (typeof UserRole)[keyof typeof UserRole]

@Directive({
  selector: '[userRoleRestriction]'
})

export class UserRoleRestrictionDirective implements OnInit{
  @Input('userRoleRestriction') roles: UserRole[] = []

  constructor(private viewContainer: ViewContainerRef, private template: TemplateRef<any>) { }

  ngOnInit(): void {
    this.viewContainer.createEmbeddedView(this.template);
    this.hideByRole()
  }

  private hideByRole(): void {
    const currentRole = localStorage.getItem('DwallRole') || '';
    const isHide = this.roles.includes(currentRole as UserRoleType);
    if (isHide) this.viewContainer.clear();
  }
}
